import React, { SyntheticEvent, useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box } from '@mui/material';
import Tab from '@mui/material/Tab';
import SportUnitiesPage from './Unities';
import SportsHallsPage from './Halls';
import HeaderDashboard from 'pages/DashboardPageClient/_components/_ui/Header';
import { t } from 'i18next';

const SportsPage = () => {
  const [value, setValue] = useState('1');

  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <>
      <HeaderDashboard></HeaderDashboard>
      <TabContext value={value}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            mt: '-50px',
            width: '50%',
          }}
        >
          <TabList onChange={handleChange}>
            <Tab label={t('sportsPage.sportsFacilities')} value="1" />
            <Tab label={t('sportsPage.sportsCourts')} value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <SportUnitiesPage />
        </TabPanel>
        <TabPanel value="2">
          <SportsHallsPage />
        </TabPanel>
      </TabContext>
    </>
  );
};

export default SportsPage;
